import { Pipe, PipeTransform } from '@angular/core';
import { AlarmSchema } from '../models/alarmSchema';

@Pipe({
  name: 'alarmSchema'
})
export class AlarmSchemaPipe implements PipeTransform {

  transform(level: number, schema?: AlarmSchema[]): any {
    if(!schema) return '#FFFFFF';
    switch(level) {
      case 1: {
        return `#${schema.find(s => s.schema_id == 1).schema_colour.toString(16).padStart(6,'0')}`;
      }
      case 2: {
        return `#${schema.find(s => s.schema_id == 2).schema_colour.toString(16).padStart(6,'0')}`;
      }
      case 3: {
        return `#${schema.find(s => s.schema_id == 3).schema_colour.toString(16).padStart(6,'0')}`;
      }
      case 4: {
        return `#${schema.find(s => s.schema_id == 4).schema_colour.toString(16).padStart(6,'0')}`;
      }
      case 5: {
        return `#${schema.find(s => s.schema_id == 5).schema_colour.toString(16).padStart(6,'0')}`;
      }
      default: {
        return '#FFFFFF';
      }
    }
  }

}
